module.exports = __webpack_public_path__ + "static/media/manzo_10_thumb.bb145180.png";